/** Colours a new tag gets, in turn. */
export const TAG_COLORS = ['#7c3aed', '#2563eb', '#16a34a', '#dc2626', '#d97706', '#0891b2', '#db2777', '#059669']

/** Colour for the next tag, given how many tags exist already. */
export function nextTagColor(existingCount: number): string {
  return TAG_COLORS[existingCount % TAG_COLORS.length]
}
